export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/right-green-icon.04ea90b2.svg","height":10,"width":6,"blurWidth":0,"blurHeight":0};